import { createContext } from "react";

export type AdminUser = {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
};

export type AdminAuthContextValue = {
  adminUser: AdminUser | null;
  isAuthenticated: boolean;
  isBootstrapping: boolean;
  loginWithGoogle: (idToken: string) => Promise<void>;
  logout: () => Promise<void>;
};

export const AdminAuthContext = createContext<AdminAuthContextValue | null>(
  null,
);
